import { render, staticRenderFns } from "./HeaderForListComponent.vue?vue&type=template&id=21f87326&scoped=true&"
import script from "./HeaderForListComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderForListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f87326",
  null
  
)

export default component.exports